// MapLibre dash array patterns for different border types
export const DASH_ARRAY_PATTERNS = {
  SOLID: [] as number[],
  DASHED: [6, 6] as number[], // 6px dash, 6px gap
  DOTTED: [8, 4, 2, 4] as number[], // 8px dash, 4px gap, 2px dash, 4px gap (creates dotted effect)
  DOUBLE: [] as number[], // Double border uses gap-width instead of dash array
};

// Helper function to convert border type to MapLibre dash array
export function getBorderDashArray(borderType: BorderType): number[] {
  switch (borderType) {
    case 'solid':
      return DASH_ARRAY_PATTERNS.SOLID;
    case 'dashed':
      return DASH_ARRAY_PATTERNS.DASHED;
    case 'dotted':
      return DASH_ARRAY_PATTERNS.DOTTED;
    case 'double':
      return DASH_ARRAY_PATTERNS.DOUBLE;
    default:
      return DASH_ARRAY_PATTERNS.SOLID;
  }
}

export function getBorderLineGapWidth(borderType: BorderType): number {
  if (borderType === 'double') {
    return 2;
  }
  return 0;
}

export type BorderType = 'solid' | 'dashed' | 'dotted' | 'double';
